import Hoc from "../../components/HOC";
import { MdCake, MdWork, MdFormatQuote } from "react-icons/md";
import { useNavigate } from "react-router-dom";

const Events = () => {
    const navigate = useNavigate();

    const cards = [
        {
            title: "Birthdays",
            icon: <MdCake className="text-4xl text-pink-500" />,
            description: "View and manage employee birthdays",
            path: "/birthdays",
            bgColor: "bg-white",
            textColor: "text-pink-600",
            hoverColor: "hover:shadow-lg"
        },
        {
            title: "Anniversaries",
            icon: <MdWork className="text-4xl text-blue-500" />,
            description: "View and manage work anniversaries",
            path: "/anniversaries",
            bgColor: "bg-white",
            textColor: "text-blue-600",
            hoverColor: "hover:shadow-lg"
        },
        {
            title: "Quotes",
            icon: <MdFormatQuote className="text-4xl text-purple-500" />,
            description: "View and manage technical quotes",
            path: "/quotes",
            bgColor: "bg-white",
            textColor: "text-purple-600",
            hoverColor: "hover:shadow-lg"
        }
    ];

    return (
        <div className="container mx-auto p-4 md:p-6">
            <h1 className="text-2xl font-semibold mb-6">Events Dashboard</h1>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {cards.map((card, index) => (
                    <div
                        key={index}
                        className={`${card.bgColor} ${card.hoverColor} p-6 rounded-lg shadow-md transition-all duration-300 border border-gray-200`}
                    >
                        <div className="flex items-center gap-4 mb-4">
                            {card.icon}
                            <h2 className={`text-xl font-semibold ${card.textColor}`}>
                                {card.title}
                            </h2>
                        </div>
                        <p className="text-gray-600 text-sm mb-4">{card.description}</p>
                        <button
  onClick={() => navigate(card.path)}
  className="text-primary hover:underline text-sm font-medium"
>
  View All
</button>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Hoc(Events);
